export type GetEnvironmentCopyRequestsResponse = {
  envrnmntCopyDplymntReqMng: EnvironmentCopyRequest[];
};

export type EnvironmentCopyRequest = {
  envrnmntCopyDplymntReqSeqNum: number;
  envrnmntIdFrom: string;
  envrnmntIdTo: string;
  reqDtime: string;
  reqUser: string;
  userName: string;
  envrnmntCopyDplymntReqRsltTypeCd: string;
  envrnmntCopyDplymntReqRsltTypeName: string;
  dplymntComplDtime: string;
  errInfo: string;
  updateDateTime: string;
};
